import { render, staticRenderFns } from "./HistoryEventsTable.vue?vue&type=template&id=08ab44b1"
import script from "./HistoryEventsTable.vue?vue&type=script&lang=js"
export * from "./HistoryEventsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports